import { App } from '@capacitor/app';
import { Capacitor, WebView } from '@capacitor/core';

export interface AppVersionData {
  runningVersion: string;
  nativeVersion: string;
  webViewPath: string;
  isNative: boolean;
}

/**
 * The version of the web bundle currently executing, read synchronously from the
 * `<meta name="version">` tag the build stamps into index.html.
 *
 * This is the *running* version, not the compiled-in `__APP_VERSION__`: after an
 * OTA update the WebView serves a different bundle, and only the meta tag moves
 * with it. Sync so log entries can always carry a version, even the ones emitted
 * before the async native lookups in `getAppVersionData` resolve.
 */
export function getWebAppVersion(): string {
  if (typeof document === 'undefined') return 'unknown';

  return document.querySelector('meta[name="version"]')?.getAttribute('content') || 'unknown';
}

export async function getAppVersionData(): Promise<AppVersionData> {
  const runningVersion = getWebAppVersion();

  let nativeVersion = '';
  let webViewPath = '';
  const isNative = Capacitor.isNativePlatform();

  if (isNative) {
    try {
      const info = await App.getInfo();
      nativeVersion = info.version;
    } catch (e) {
      console.error('Failed to get native app info', e);
    }

    try {
      const pathInfo = await WebView.getServerBasePath();
      webViewPath = pathInfo.path || '';
    } catch (e) {
      console.error('Failed to get webview path', e);
    }
  }

  return {
    runningVersion,
    nativeVersion,
    webViewPath,
    isNative,
  };
}
